var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBoat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 10,
    viewBox: "0 0 35 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9082 9.05261H33.7007V5.86476H32.9082V9.05261Z",
    fill: "#524C60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2666 4.05464H34.9839V5.33112C34.9839 5.76768 34.6983 6.15321 34.2805 6.28031L30.2666 7.50244V4.05464Z",
    fill: "#EC4242"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2666 4.05457H34.9839L33.9541 3.33542C33.4451 2.98007 32.8395 2.78956 32.2187 2.78956H31.1965C30.6829 2.78956 30.2666 3.2062 30.2666 3.71975V4.05457Z",
    fill: "#FF8B81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7129 4.31128H22.0015L21.8572 2.67493H21.7129V4.31128Z",
    fill: "#7AB1B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1235 4.57104H20.4122L20.2678 2.93469H20.1235V4.57104Z",
    fill: "#7AB1B8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3833 4.61316H28.7947V2.08528L27.7483 2.59037L27.3833 4.61316Z",
    fill: "#DEE8FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95622 9.05261H31.9269V5.26215L0.729492 4.05452C1.03412 6.45771 3.2139 8.15987 4.95622 9.05261Z",
    fill: "url(#paint0_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.8121 9.05261H29.7378L31.9269 4.96024C23.1042 4.72506 13.4682 4.66286 3.77393 4.20758C4.07855 6.61108 7.54779 8.58828 9.8121 9.05261Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.713 4.31128C12.426 4.13315 12.0323 3.82188 0 3.15406L15.7871 2.78965L19.8128 3.15406L21.713 4.31128Z",
    fill: "#FF8B81"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3797 4.55149C23.0927 4.37336 12.0323 3.82177 0 3.15395V4.05455C11.9266 4.71965 23.0115 5.23682 32.3797 5.45178V4.55149Z",
    fill: "#EC4242"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73386 5.835L8.32069 5.8999C8.47316 5.90624 8.60207 5.78759 8.60841 5.63483C8.61475 5.48206 8.4961 5.35315 8.34334 5.34711L6.7565 5.2819C6.60374 5.27556 6.47482 5.39421 6.46848 5.54697C6.46244 5.69974 6.58109 5.82866 6.73386 5.835Z",
    fill: "#7AB1B8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7809 6.00101L12.3678 6.06592C12.5205 6.07226 12.6495 5.95361 12.6555 5.80084C12.6618 5.64808 12.5432 5.51916 12.3904 5.51282L10.8036 5.44791C10.6508 5.44157 10.5219 5.56022 10.5159 5.71299C10.5095 5.86576 10.6282 5.99467 10.7809 6.00101Z",
    fill: "#7AB1B8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8278 6.16673L16.4147 6.23194C16.5674 6.23828 16.6963 6.11932 16.7027 5.96686C16.709 5.81409 16.5901 5.68518 16.4376 5.67884L14.8508 5.61393C14.698 5.60759 14.5691 5.72624 14.5627 5.87901C14.5564 6.03177 14.6754 6.16069 14.8278 6.16673Z",
    fill: "#7AB1B8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2844 1.16825e-05H20.7185L19.8128 3.15405L15.7871 2.78965L19.2844 1.16825e-05Z",
    fill: "url(#paint1_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2846 1.14441e-05H20.7187L19.8129 3.15405L19.2287 3.08582L20.209 0.432649L18.8257 0.366223L19.2846 1.14441e-05Z",
    fill: "#FF8B81"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6979 9.35461H1.74332C1.57666 9.35461 1.44141 9.21966 1.44141 9.05271C1.44141 8.88605 1.57666 8.7508 1.74332 8.7508H34.6979C34.8645 8.7508 34.9998 8.88605 34.9998 9.05271C34.9998 9.21966 34.8645 9.35461 34.6979 9.35461Z",
    fill: "#50B3D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 16.3282,
    y1: 9.05261,
    x2: 16.3282,
    y2: 4.05452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#378D9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F273D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 18.2528,
    y1: 3.15405,
    x2: 18.2528,
    y2: 0.0000116825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#524C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#524C60",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoat);
export default __webpack_public_path__ + "static/media/boat.a4744c45db55862a78923cd6bc9050d8.svg";
export { ForwardRef as ReactComponent };